import values from 'lodash/values';
import { atom } from 'jotai';
import { ListParamsProject } from '../types';
import { PROJECT_STATUS } from '../lib/constants';

export const projectsPaginationAtom = atom<ListParamsProject>({
  sort: {
    createdAt: 'desc',
  },
  filters: {
    status: { $in: values(PROJECT_STATUS) },
  },
} as ListParamsProject);
